var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-slow","mode":"out-in"}},[_c('div',{class:[
      'footer',
    ]},[_vm._v(" FOOTER ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }